@if (availability.unavailable()) {
  <!-- #1174: API did not answer during SSR (overload) — say so instead of an empty page -->
  <div role="alert" class="sticky top-0 z-50 bg-warning px-4 py-2 text-center text-sm text-warning-foreground">
    Сайт сейчас перегружен — часть страницы не загрузилась. Обновите страницу через минуту.
  </div>
}
<router-outlet/>
